<template>
  <div class="xj-basic-detail-page">
    <el-card class="box-form">
      <c-title slot="header" :title="'详情'"></c-title>
      <student-info :id="id" :familyFlag="true"></student-info>
    </el-card>
  </div>
</template>

<script>
import CTitle from "@/components/CTitle";
import StudentInfo from "@/components/StudentInfo/index.vue";
import { mapState } from "vuex";
export default {
  components: {
    CTitle,
    StudentInfo,
  },
  data() {
    return {
      currentTab: "first",
      studentInfo: {},
      studentId: "",
      id: "",
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {},
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    handleBack() {
      this.$router.go(-1);
    },
    getCurrentPanel(current) {
      switch (current) {
        case "1":
          this.currentTab = "first";
          break;
        case "2":
          this.currentTab = "second";
          break;
      }
    },
  },
};
</script>


